import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { instance } from "../../utils/axiosConfig";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setAuthentication } from "../../store/slices/authSlice";
import { BreedingRhombusSpinner } from "react-epic-spinners";

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const isAuthenticated = JSON.parse(localStorage.getItem("authenticated"));
  const token = JSON.parse(localStorage.getItem("token"));
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  useEffect(() => {
    if (token && isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsAuthenticating(true);
    try {
      const resp = await instance.post("/user/login", { email, password });
      if (resp.data) {
        setTimeout(() => {
          setIsAuthenticating(false);
          const { message, token, user } = resp.data;
          if (token) {
            dispatch(setAuthentication({ token, user }));
            navigate("/dashboard");
            toast.info(message);
          }
        }, 2000);
      }
    } catch (err) {
      if (err) {
        setTimeout(() => {
          setIsAuthenticating(false);
          const { message } = err.response.data;
          toast.error(message);
        }, 2000);
      }
    }
  };
  return (
    <section className="m-auto bg-yellow-50 xl:container px-12 sm:px-0 mx-auto">
      <div className="mx-auto h-full sm:w-max relative">
        <div className="m-auto  py-12">
          <div className="mt-12 rounded-3xl border bg-gray-50 -mx-6 sm:-mx-10 p-8 sm:p-10">
            {!isAuthenticating && (
              <>
                <h3 className="text-2xl text-center font-semibold text-yellow-700">
                  Login to your account.
                </h3>
                {/* <div className="mt-12 flex flex-wrap sm:grid gap-6 grid-cols-2">
                  <button className="w-full h-11 rounded-full border border-gray-300/75 bg-white px-6 transition active:bg-gray-50">
                    <div className="w-max mx-auto flex items-center justify-center space-x-4">
                      <img
                        src="https://tailus.io/sources/blocks/plus-social/preview/images/google.svg"
                        className="w-5"
                        alt=""
                      />
                      <span className="block w-max text-sm font-semibold tracking-wide text-black-700">
                        With Google
                      </span>
                    </div>
                  </button>
                  <button className="w-full h-11 rounded-full bg-gray-900 px-6 transition hover:bg-gray-800 focus:bg-gray-700 active:bg-gray-600">
                    <div className="w-max mx-auto flex items-center justify-center space-x-4 text-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        className="w-5"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                      </svg>
                      <span className="block w-max text-sm font-semibold tracking-wide text-white">
                        With Github
                      </span>
                    </div>
                  </button>
                </div> */}

                <form onSubmit={handleSubmit} className="mt-10 space-y-8">
                  <div>
                    <div className="w-full relative before:absolute before:bottom-0 before:h-0.5 before:left-0 before:origin-right focus-within:before:origin-left before:right-0 before:scale-x-0 before:m-auto before:bg-yellow-900 focus-within:before:!scale-x-100 before:transition before:duration-300">
                      <input
                        id="email"
                        type="email"
                        placeholder="Your Email"
                        className="w-full bg-transparent pb-3  border-b border-yellow-200 transition outline-none"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col items-end">
                    <div className="w-full relative before:absolute before:bottom-0 before:h-0.5 before:left-0 before:origin-right focus-within:before:origin-left before:right-0 before:scale-x-0 before:m-auto before:bg-yellow-900 focus-within:before:!scale-x-100 before:transition before:duration-300">
                      <input
                        id="password"
                        type="password"
                        placeholder="Your Password"
                        className="w-full bg-transparent pb-3  border-b border-yellow-200 transition outline-none"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="w-full mb-4 rounded-full bg-yellow-700 h-11 flex items-center justify-center px-6 py-3 transition hover:bg-yellow-600 focus:bg-yellow-600 active:bg-yellow-900"
                    >
                      <span className="text-base font-semibold text-white">
                        Login
                      </span>
                    </button>
                    <Link to="/signup" className="w-max p-3">
                      Don't have an account?
                      <span className="ml-2 text-sm tracking-wide text-yellow-700">
                        Signup
                      </span>
                      .
                    </Link>
                  </div>
                </form>
              </>
            )}
            {isAuthenticating && (
              <div className="flex my-20 p-4 items-center space-x-2">
                <BreedingRhombusSpinner size={100} color="#202030" />
                <p className="text-xl animate-pulse">Authenticating...</p>
              </div>
            )}
          </div>
          <div className="border-t pt-12 text-gray-500">
            <div className="flex space-x-4 items-center">
              <div>&copy; Lipia Online</div>
              <Link to="/contact" className="text-sm hover:text-sky-900">
                Contact
              </Link>
              <p className="text-sm hover:text-sky-900">Privacy & Terms</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
